import { render, staticRenderFns } from "./CardInatividade.vue?vue&type=template&id=253d58cc&scoped=true&"
import script from "./CardInatividade.vue?vue&type=script&lang=js&"
export * from "./CardInatividade.vue?vue&type=script&lang=js&"
import style0 from "./CardInatividade.vue?vue&type=style&index=0&id=253d58cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253d58cc",
  null
  
)

export default component.exports